__turbopack_context__.v({
  "border--none": "x6Y-5W_border--none",
  "borderColor--warning": "x6Y-5W_borderColor--warning",
  "colorScheme--muted": "x6Y-5W_colorScheme--muted",
  "colorScheme--none": "x6Y-5W_colorScheme--none",
  "container": "x6Y-5W_container",
  "field": "x6Y-5W_field",
  "input": "x6Y-5W_input",
  "isEmpty": "x6Y-5W_isEmpty",
  "size--lg": "x6Y-5W_size--lg",
  "size--sm": "x6Y-5W_size--sm",
  "width--maxcontent": "x6Y-5W_width--maxcontent",
  "wiggle--a": "x6Y-5W_wiggle--a",
  "wiggle--b": "x6Y-5W_wiggle--b",
});
